import { useTranslation } from 'react-i18next';
import { useCallback, useEffect, useState, useContext } from 'react';
import { ReactComponent as CloseIcon } from '../SearchPage/assets/close.svg';
import { API } from '../../API';
import Select from 'react-select';
import styles from './UserSettingsPage.module.scss';
import { UserSettingsContext } from './contexts/UserSettingsContext';
import { useCurrentUser } from '../../contexts/CurrentUser';
import { languageNamesMapping } from '../../utils/languages';
import { changeLanguage } from 'i18next';
import { toast } from 'react-toastify';
import { showRequestError } from '../../utils/requestError';

export const BasicSettings = () => {
  const { t } = useTranslation();

  const {
    user,
    error
  } = useContext(UserSettingsContext);

  const [currentUser, setCurrentUser] = useCurrentUser();
  const [firstName, setFirstName] = useState(user?.first_name || '');
  const [lastName, setLastName] = useState(user?.last_name || '');
  const [email, setEmail] = useState(user?.email || '');
  const [userLanguage, setUserLanguage] = useState(user?.language ? {value: user.language, label: t(languageNamesMapping[user.language])} : {value: 'EN', label: t('English')});
  const [translationLanguage, setTranslationLanguage] = useState(user?.translation_language ? {value: user.translation_language, label: t(languageNamesMapping[user.translation_language])} : {value: null, label: t('Not selected')});
  const [errors, setErrors] = useState({});
  const [isSaving, setIsSaving] = useState(false);

  const languageOptions = [
    {value: 'EN', label: t('English')},
    {value: 'UK', label: t('Ukrainian')}
  ]

  const languageTranslationOptions = [
    {value: 'EN', label: t('English')},
    {value: 'UK', label: t('Ukrainian')},
    {value: 'FR', label: t('French')},
    {value: 'PL', label: t('Polish')},
    {value: 'RO', label: t('Romanian')},
    {value: 'DE', label: t('German')},
    {value: 'PT', label: t('Portuguese')},
  ]

  const handleProfileSubmit = (e) => {
    e.preventDefault();
    if (isSaving) return;

    setErrors({});

    if(firstName.trim().length === 0) {
      setErrors(errors => ({...errors, firstName: t('Please, fill in this field')}))
      return
    }

    if(lastName.trim().length === 0) {
      setErrors(errors => ({...errors, lastName: t('Please, fill in this field')}))
      return
    }

    let body = {};

    if(user.first_name !== firstName?.trim()) {
      body.first_name = firstName;
    }
    if(user.last_name !== lastName?.trim()) {
      body.last_name = lastName;
    }

    if(userLanguage.value !== user.language) {
      body.language = userLanguage.value;
    }

    if(translationLanguage.value !== user.translation_language) {
      body.translation_language = translationLanguage.value;
    }


    setIsSaving(true);

    API.fetch('PATCH', `/API/v1/users/me`, null, body)
      .then(() => API.fetch('GET', '/API/v1/users/me'))
      .then((data) => {
        setCurrentUser(data);
        if (data.language) {
          changeLanguage(data.language.toLowerCase());
        }
        toast.success(t('Profile settings saved'));
      })
      .catch((error) => {
        showRequestError(error, t('Profile'));
        setErrors(errors => ({...errors, general: error.message}));
      })
      .finally(() => setIsSaving(false));
  }

  return (
    <div className={styles.userSettingsSectionContainer}>
      <h3>{t('Profile')}</h3>
      <div className="form-wrapper">
        <form onSubmit={handleProfileSubmit}>
          <div className="form-element">
            <label className={styles.label} htmlFor="firstName">{t('First name')}&#42;</label>
            <input
              className=""
              id="firstName"
              name="first name"
              type="text"
              value={firstName}
              onChange={e => setFirstName(e.target.value)}
              required
            />
            <div className="error-message">
              {errors.firstName}
            </div>
          </div>
          <div className="form-element">
            <label className={styles.label} htmlFor="lastName">{t('Last name')}&#42;</label>
            <input
              className=""
              id="lastName"
              name="last name"
              type="text"
              value={lastName}
              onChange={e => setLastName(e.target.value)}
              required
            />
            <div className="error-message">
              {errors.lastName}
            </div>
          </div>
          <div className="form-element">
            <label className={styles.label} htmlFor="email">{t('Email')}</label>
            <input
              className=""
              id="email"
              name="email"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              disabled
            />
            <div className="error-message">
              {errors.email}
            </div>
          </div>
          <div className="form-element">
            <label className={styles.label} htmlFor="language">{t('System language')}</label>
            <Select
              className="chart-select"
              onChange={(data) => {
                setUserLanguage(data);
              }}
              value={userLanguage}
              options={languageOptions}
            />
          </div>
          <div className="form-element">
            <label className={styles.label} htmlFor="languageTranslation">{t('Language for translation')}</label>
            <Select
              className="chart-select"
              onChange={(data) => {
                setTranslationLanguage(data);
              }}
              value={translationLanguage}
              options={languageTranslationOptions}
            />
          </div>
          <div className="form-element">
            <div className="submit-wrapper">
              <button
                type="submit"
                className='new-button'
                disabled={isSaving}
                aria-busy={isSaving}
              >
                {isSaving ? t('Saving...') : t('Save')}
              </button>
            </div>
            {errors.general ? <div className={styles.errorMessage}>{t(errors.general)} <span
              onClick={() => setErrors({...errors, general: null})}> <CloseIcon/> </span></div> : ''}
          </div>
        </form>
      </div>
    </div>
  );
};
